import "../../../styles/Challenges.css";

function DailyCheckInButton({ onCheckin, busy }) {
  return (
    <div className="marginTop5">
      <p className="subject-1 grey-1 centerAlign yekan">امروز انجامش دادی؟</p>
      <div className="challengeCheckinRow">
        <button
          type="button"
          className="fill-container radius1-5 margin0"
          disabled={busy}
          onClick={() => onCheckin("done")}
          aria-label="بله، امروز چالش رو انجام دادم"
        >
          بله، انجام دادم
        </button>
        <button
          type="button"
          className="challengeCheckinSecondary"
          disabled={busy}
          onClick={() => onCheckin("skipped")}
          aria-label="امروز چالش رو انجام ندادم"
        >
          امروز انجامش ندادم
        </button>
      </div>
    </div>
  );
}

export default DailyCheckInButton;
